import { useState } from 'react';

const TextFormatterTool = ({ tool }) => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState(null);
  const [copyFeedback, setCopyFeedback] = useState('');

  const handleFormat = () => {
    setError(null);
    setCopyFeedback('');

    try {
      const result = tool.processor(input);
      setOutput(result);
    } catch (err) {
      setOutput('');
      setError(err.message);
    }
  };

  const handleClear = () => {
    setInput('');
    setOutput('');
    setError(null);
    setCopyFeedback('');
  };

  const handleCopy = async () => {
    if (!output) {
      return;
    }

    try {
      if (!navigator?.clipboard) {
        throw new Error('API de área de transferência indisponível.');
      }

      await navigator.clipboard.writeText(output);
      setCopyFeedback('Resultado copiado!');
      setTimeout(() => setCopyFeedback(''), 2000);
    } catch (err) {
      setCopyFeedback(`Falha ao copiar: ${err.message}`);
    }
  };

  const handleExport = () => {
    if (!output) {
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    const blob = new Blob([output], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${tool.id}.txt`;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-500 dark:text-slate-400">{tool.description}</p>

      <textarea
        value={input}
        onChange={(event) => setInput(event.target.value)}
        placeholder={tool.placeholder}
        className="h-48 w-full resize-y rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 font-mono text-sm text-slate-700 transition focus:border-brand-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-primary/40 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200"
      />

      <div className="flex flex-wrap gap-3">
        <button
          type="button"
          onClick={handleFormat}
          className="rounded-lg bg-brand-primary px-5 py-2 text-sm font-semibold text-white shadow transition hover:bg-brand-primary/90"
        >
          {tool.actionLabel ?? 'Executar'}
        </button>
        <button
          type="button"
          onClick={handleClear}
          className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
        >
          Limpar
        </button>
        <button
          type="button"
          onClick={handleCopy}
          className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
          disabled={!output}
        >
          Copiar
        </button>
        <button
          type="button"
          onClick={handleExport}
          className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:bg-slate-100 dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
          disabled={!output}
        >
          Exportar
        </button>
      </div>

      {error && (
        <div className="rounded-lg border border-rose-300 bg-rose-50 px-4 py-3 text-sm text-rose-600 dark:border-rose-500/50 dark:bg-rose-500/10 dark:text-rose-300">
          {error}
        </div>
      )}

      {copyFeedback && (
        <div className="text-sm font-medium text-brand-primary">{copyFeedback}</div>
      )}

      <div>
        <h3 className="text-sm font-semibold text-slate-600 dark:text-slate-300">
          Resultado
        </h3>
        <pre className="mt-2 max-h-64 overflow-auto rounded-lg border border-slate-200 bg-slate-950/90 px-4 py-3 text-sm text-slate-100 dark:border-slate-700 dark:bg-slate-900">
          {output || 'Execute a ferramenta para visualizar o resultado.'}
        </pre>
      </div>
    </div>
  );
};

export default TextFormatterTool;
